<c-card class="broadcast-card shadow-sm border-0" *transloco="let t">
  <c-card-body>
    <div class="broadcast-page-header">
      <div class="broadcast-page-header__title">
        <span class="broadcast-page-header__icon"><i class="fa-solid fa-bullhorn"></i></span>
        <div>
          <h1 class="broadcast-page-header__heading">{{ draftId > 0 ? t('Edit Team Broadcast') : t('Create Team Broadcast') }}</h1>
          <p class="broadcast-page-header__subtitle">{{ t('Compose a push notification and choose who receives it.') }}</p>
        </div>
      </div>
      <button cButton class="btn btn-ghost" (click)="cancel()">
        <i class="fa-solid fa-arrow-left me-1"></i> {{ t('Back') }}
      </button>
    </div>

    <form [formGroup]="formGroup" cForm>
      <c-row class="g-4">
        <c-col md="5">
          <div class="broadcast-panel">
            <h5 class="broadcast-section-title"><i class="fa-solid fa-users me-2"></i>{{ t('Recipients') }}</h5>

            <div class="audience-toggle" [class.audience-toggle--active]="formGroup.value.send_all">
              <div class="audience-toggle__text">
                <span class="audience-toggle__title">{{ t('Send to All Users') }}</span>
                <span class="audience-toggle__hint">{{ t('Everyone in your workforce') }}</span>
              </div>
              <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" id="sendAll" formControlName="send_all">
              </div>
            </div>

            <div class="audience-toggle" [class.audience-toggle--active]="formGroup.value.on_shift_only">
              <div class="audience-toggle__text">
                <span class="audience-toggle__title">{{ t('On Shift Workers Only') }}</span>
                <span class="audience-toggle__hint">{{ t('Skip anyone not currently on shift') }}</span>
              </div>
              <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" id="onShiftOnly" formControlName="on_shift_only">
              </div>
            </div>

            <div *ngIf="!formGroup.value.send_all" class="audience-picker">
              <div class="mb-3" *ngIf="okService.groups?.length > 0">
                <label class="broadcast-label">{{ t('Groups') }}</label>
                <ng-select [items]="okService.groups"
                           bindLabel="name"
                           bindValue="id"
                           [multiple]="true"
                           placeholder="{{ t('Add Groups') }}"
                           formControlName="group_ids">
                </ng-select>
              </div>
              <div class="mb-1">
                <label class="broadcast-label">{{ t('People') }}</label>
                <ng-select [items]="workers"
                           bindLabel="name"
                           bindValue="worker_id"
                           [multiple]="true"
                           placeholder="{{ t('Add People') }}"
                           formControlName="worker_ids">
                </ng-select>
              </div>
            </div>
          </div>
        </c-col>

        <c-col md="7">
          <div class="broadcast-panel">
            <h5 class="broadcast-section-title"><i class="fa-solid fa-pen-to-square me-2"></i>{{ t('Compose Message') }}</h5>

            <div class="mb-3">
              <label class="broadcast-label">{{ t('Title') }} <span class="text-danger">*</span></label>
              <input cFormControl type="text" formControlName="title" placeholder="{{ t('Short, clear headline') }}"
                     [ngClass]="{ 'is-invalid border-danger': submitted && f['title'].errors }" />
            </div>
            <div class="mb-3">
              <label class="broadcast-label">{{ t('Summary') }} <span class="text-danger">*</span></label>
              <textarea cFormControl rows="2" formControlName="summary" placeholder="{{ t('This is the push notification body') }}"
                        [ngClass]="{ 'is-invalid border-danger': submitted && f['summary'].errors }"></textarea>
            </div>
            <div class="mb-3">
              <label class="broadcast-label">{{ t('Detailed Message') }} <span class="text-danger">*</span></label>
              <textarea cFormControl rows="6" formControlName="body" placeholder="{{ t('The full message shown when the notification is opened') }}"
                        [ngClass]="{ 'is-invalid border-danger': submitted && f['body'].errors }"></textarea>
            </div>
            <div class="mb-1">
              <label class="broadcast-label">{{ t('Priority') }}</label>
              <select cSelect formControlName="priority">
                <option value="normal">{{ t('Normal') }}</option>
                <option value="critical">{{ t('Critical – override Do Not Disturb') }}</option>
              </select>
            </div>
          </div>
        </c-col>
      </c-row>

      <div class="alert alert-danger mt-3 mb-0" *ngIf="alert?.type === 'error'">
        <i class="fa-solid fa-circle-exclamation me-1"></i>{{ alert.content }}
      </div>

      <div class="broadcast-actions">
        <button cButton class="btn btn-ghost" type="button" (click)="cancel()" [disabled]="saving">{{ t('Cancel') }}</button>
        <span class="broadcast-actions__spacer"></span>
        <button cButton class="btn btn-outline-secondary" type="button" (click)="saveDraft()" [disabled]="saving">
          <i class="fa-solid fa-floppy-disk me-1"></i> {{ t('Save & Close') }}
        </button>
        <button cButton class="btn btn-create" type="button" (click)="openSendConfirm()" [disabled]="saving">
          <i class="fa-solid fa-paper-plane me-1"></i> {{ t('Send Now') }}
        </button>
      </div>
    </form>
  </c-card-body>
</c-card>

<c-modal [visible]="showConfirmModal" (visibleChange)="showConfirmModal = $event" *transloco="let t">
  <c-modal-header>
    <h5 cModalTitle>{{ t('Confirm Send') }}</h5>
  </c-modal-header>
  <c-modal-body>
    {{ t('Are you sure you want to send this notification? Clicking Yes will send this notification to all selected recipients and you will not be able to make any additional changes.') }}
  </c-modal-body>
  <c-modal-footer>
    <button cButton class="btn btn-ghost" (click)="showConfirmModal = false">{{ t('No') }}</button>
    <button cButton class="btn btn-create" (click)="confirmSend()">
      <i class="fa-solid fa-paper-plane me-1"></i> {{ t('Yes, Send') }}
    </button>
  </c-modal-footer>
</c-modal>
